  <!-- 订单应收 -->
  <template>
  <div>
    <!-- 按钮列表 -->
    <butotn-plug
      :btndata="BTN_CONFIG"
      @btnEvent="callBack"
      @clearBtns="clearBtns"
      @moreParam="moreParam"
      @queryBtn_ok="queryBtn_ok"
      @moreHandle="topCommandBtns"
      ref="btnList"
    />
    <!-- 查询列表 -->
    <input-plug
      ref="queryForm"
      :form-config="baseConfig"
      :form-data="queryData"
      :More="isHaseMore"
    >
      <template slot="time1">
        <multitime
          :timeType="timeType"
          :timeTypes="timeTypes"
          :startTime="startTime_a"
          :endTime="endTime_a"
          @timestatus="timestatus"
          @queryBtn_ok="queryBtn_time"
        >
        </multitime
      ></template>
    </input-plug>
    <!-- 表格 -->
    <table-plug
      :tableConfig="tableConfig"
      :defaulthead="myTableHeard"
      :totals="totalArr"
      @selectChange="handleSelectionChange"
      @jumpPage="goYdDetails"
    ></table-plug>
    <!-- 分页 -->
    <paging
      ref="pags"
      :pageNum="pageStart"
      :total="pageCount"
      :size="pageTotal"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
    >
    </paging>
    <!--        自定义表头           -->
    <sorttable
      :show_sortTableHeard="show_sortTableHeard"
      :allCheck="allCheck"
      :sortName="sortName"
      :tabelHeadeTitle="tabelHeadeTitle"
      :originalTabelHeadeTitle="originalTabelHeadeTitle"
      :selectLength="selectLength"
      @cancelSortHeard="cancelSortHeard"
      @confirmOk="confirmOk"
      @checktab="checktab"
      @checkAll="checkAll"
      @closeDias="closeDias"
    >
    </sorttable>
    <!-- 核销 -->
    <my-dialog
      :diaWidth="diaWidth"
      :dialogTitle="dialogTitle(1)"
      :isShowDialog="isShowDialog_1"
      @handleCloseDia="handleCloseDia(1)"
      @diaCancelBtn="diaCancelBtn(1)"
      @diaConfirmBtn="diaConfirmBtn(1)"
    >
      <dia-form :diaFormConfig="diaFormConfig" :baseModel="baseModel">
        <template slot="phone">
          <img-upload />
        </template>
      </dia-form>
    </my-dialog>
  </div>
</template>
   <script >
import { mixin_1 } from "@/assets/js/Mixins/mixin";
import sorttable from "@/components/sortTemplate.vue"; //自定义排序表头
import ButotnPlug from "@/components/Modules/ButtonPlug.vue";
import InputPlug from "@/components/Modules/InputPlug.vue";
import multitime from "@/components/multiTime.vue";
import paging from "@/components/pagings.vue"; //分页组件
import TablePlug from "@/components/Modules/TablePlug.vue";
import MyDialog from "@/components/Dialog.vue";
import DiaForm from "@/pages/VMS/VMSConpon/DiaForm.vue";
import ImgUpload from "@/components/Modules/ImgUpload.vue";
import RecordTable from "@/pages/FinancialManagement/FinancialWriteOff/FMMOD/RecordTable.vue";
export default {
  mixins: [mixin_1],
  components: {
    ButotnPlug,
    InputPlug,
    multitime,
    TablePlug,
    paging,
    sorttable,
    MyDialog,
    DiaForm,
    ImgUpload,
    RecordTable,
  },
  data() {
    return {
      // 按钮配置
      BTN_CONFIG: [
        {
          name: "审核",
          method: {
            methodname: "Examine",
            title: "确认要审核通过所选数据？",
          },
        },
        {
          name: "返审核",
          method: {
            methodname: "UnExamine",
            title: "确认要返审核所选数据？",
          },
        },
        {
          name: "核销",
          method: "Writeoff",
        },
        {
          name: "返核销",
          method: {
            methodname: "UnWriteoff",
            title: "确认要返核销所选数据？",
          },
        },

        {
          type: true,
          name: "更多操作",
          options: [
            {
              handleName: "dc",
              label: "导出",
            },
            {
              handleName: "bgsz",
              label: "表格设置",
            },
            {
              handleName: "dy",
              label: "打印",
            },
          ],
        },
      ],
      // 更多搜索
      isHaseMore: false,
      //  查询框
      baseConfig: [
        {
          type: "timeSelect",
          slotName: "time1",
        },
        {
          type: "select",
          label: "结算单位",
          field: "id",
          placeholder: "请输入",
          selectOptions: [{ label: "全部", val: "1" }],
        },
        {
          type: "select",
          label: "客户单号",
          field: "id",
          placeholder: "请输入",
          selectOptions: [{ label: "全部", val: "1" }],
        },
      ],

      queryData: {
        id: "",
        name: "",
        phone: "",
        status: "",
      },
      //  时间类型
      timeTypes: [
        {
          value: "0",
          label: "创建日期",
        },
      ],
      timeType: "0", //  时间类型
      startTime_a: "",
      endTime_a: "",
      // 表格配置
      tableConfig: {
        tableHeigth: "75vh",
        tableData: [
          {
            a: "明细",
            b: "测试数据",
            c: "测试数据",
          },
          {
            a: "明细",
            b: "测试数据",
            c: "测试数据",
          },
          {
            a: "明细",
            b: "测试数据",
            c: "测试数据",
          },
          {
            a: "明细",
            b: "测试数据",
            c: "测试数据",
          },
          {
            a: "明细",
            b: "测试数据",
            c: "测试数据",
          },
          {
            a: "明细",
            b: "测试数据",
            c: "测试数据",
          },
          {
            a: "明细",
            b: "测试数据",
            c: "测试数据",
          },
        ],
      },
      myTableHeard: [],
      tabelHeadeTitle: [
        {
          name: "明细",
          field: "a",
          Hyperlink: true, //是否展示超链接 可选填
          width: "120", // default：120
          sort: 3,
          isShow: true, //是否展示
          isTotal: true, //是否开启合计 default：false
          isSort: true, //表格设置里面是否可以排序 default：false
        },
        {
          name: "客户单号",
          field: "b",
          sort: 4,
          isShow: true,
          isSort: true,
        },
        {
          name: "应收合计",
          field: "c",
          sort: 5,
          isShow: true,
          isTotal: true,
          isSort: true,
        },
        {
          name: "实收合计",
          field: "c",
          sort: 5,
          isShow: true,
          isTotal: true,
          isSort: true,
        },
        {
          name: "结算单位",
          field: "billStorepackChannelNumber",
          sort: 6,
          isShow: true,
        },
        {
          name: "收货人",
          field: "frameName",
          sort: 1,
          isShow: true,
        },
        {
          name: "备注",
          field: "packageStatusShow",
          sort: 1,
          isShow: true,
        },
        {
          name: "创建时间",
          field: "storepackStatusShow",
          sort: 18,
          isShow: true,
          isSort: true,
        },
        {
          name: "创建人",
          field: "isRejectionShow",
          sort: 19,
          isShow: true,
        },
        {
          name: "审核状态",
          field: "checkStatusShow",
          sort: 1,
          isShow: true,
        },
        {
          name: "审核人",
          field: "itemCategoryShow",
          sort: 1,
          isShow: true,
        },
        {
          name: "审核时间",
          field: "intoStockTime",
          sort: 2,
          isShow: true,
          isSort: true,
        },
        {
          name: "核销人",
          field: "storageName",
          sort: 2,
          isShow: true,
        },

        {
          name: "核销状态",
          field: "boxCount",
          sort: 1,
          isShow: true,
        },
        {
          name: "核销时间",
          field: "packageWeight",
          sort: 1,
          isShow: true,
          isSort: true,
        },
        {
          name: "资金账号",
          field: "packageWeight",
          sort: 1,
          isShow: true,
        },
        {
          name: "核销备注",
          field: "packageVolume",
          sort: 1,
          isShow: true,
        },
      ],
      sortName: "订单应收", //  排序名
      // 核销弹窗
      diaWidth: "60%",
      isShowDialog_1: false,
      diaFormConfig: [
        {
          gutter: 0,
          formItem: [
            {
              span: 8,
              title: "核销金额",
              itemType: "input",
              field: "aaa",
              placeholder: "请输入",
            },
            {
              span: 8,
              title: "核销资金账号",
              itemType: "select",
              field: "aaa",
              placeholder: "请选择",
              options: [
                {
                  label: "上楼费",
                  val: 1,
                },
                {
                  label: "验货费",
                  val: 1,
                },
                {
                  label: "加急费",
                  val: 1,
                },
              ],
            },
            {
              span: 8,
              title: "核销时间",
              itemType: "timeselect",
              field: "aaa",
              datetype: "datetime",
              placeholder: "选择时间",
            },
          ],
        },

        {
          gutter: 0,
          formItem: [
            {
              span: 24,
              title: "备注",
              itemType: "textarea",
              field: "aaa",
              placeholder: "请选择",
            },
          ],
        },
        {
          gutter: 0,
          formItem: [
            {
              span: 24,
              title: "图片",
              itemType: "upload",
              slot: "phone",
            },
          ],
        },
      ],
      baseModel: {
        aaa: 1,
      },
    };
  },
  updated() {
    if (this.show_sortTableHeard) {
      // 排序表头
      let arr = this.tabelHeadeTitle;
      for (var i = 0; i < arr.length; i++) {
        arr[i].sort = i + 1;
      }
      this.tabelHeadeTitle = arr;
    }
  },
  created() {},
  methods: {
    // 审核
    Examine() {
      this.$message.success("ok");
    },
    // 返审核
    UnExamine() {
      this.$message.success("ok");
    },

    // 核销
    Writeoff() {
      this.isShowDialog_1 = true;
    },
    // 返核销
    UnWriteoff() {
      this.$message.success("ok");
    },
    // 更多搜索
    moreParam(e) {
      this.isHaseMore = e;
    },
    //顶部跟多按钮的操作
    topCommandBtns(a) {
      if (a === "bgsz") {
        // 设置模板按钮
        // this.myModel();
        this.$TOOLS.myModel(this);
      }
      if (a === "dyyd") {
        // 打印运单
      }
      if (a === "dybq") {
        // 打印标签
      }
      if (a === "dr") {
        // 导入
      }
      if (a === "dc") {
        // 导出
      }
    },
    // 当前弹窗的标题赋值
    dialogTitle(e) {
      return e === 1 ? "核销" : "编辑";
    },
    // 清空查询
    clearBtns() {
      console.log(2222);
    },
    // 查询事件
    queryBtn_ok() {
      console.log(this.queryData);
    },
    // // 表格选择事件
    handleSelectionChange(e) {
      console.log("表格选择事件");
    },
    // 跳转运单详情
    goYdDetails(a) {
      this.$router.push({
        path: "/FM/OrderDetails/",
      });
    },
    //顶部跟多按钮的操作
    topCommandBtns(a) {
      if (a === "bgsz") {
        // 设置模板按钮
        // this.myModel();
        this.$TOOLS.myModel(this);
      }
      if (a === "dyyd") {
        // 打印运单
      }
      if (a === "dybq") {
        // 打印标签
      }
      if (a === "dr") {
        // 导入
      }
      if (a === "dc") {
        // 导出
      }
    },
    // 整单核销
    //  弹窗关闭事件(左上角的x和关闭按钮都算)
    handleCloseDia(e) {
      this.isShowDialog_1 = false;
    },
    //  弹窗确认保存事件
    diaConfirmBtn(e) {
      this.isShowDialog_1 = false;
    },
    //  关闭弹窗按钮事件(关闭按钮)
    diaCancelBtn(e) {
      this.isShowDialog_1 = false;
    },
  },
};
</script>
  <style scoped lang="less">
</style>
                    